import React from 'react';

const DisabledLayover = ({ children, disabled }) => {
  return (
    <div style={{ position: 'relative', isolation: 'isolate' }}>
      {children}
      {disabled && (
        <div
          style={{
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: 'rgba(255, 255, 255, 0.7)',
            zIndex: 999,
            cursor: 'not-allowed',
          }}
        />
      )}
    </div>
  );
};

export default DisabledLayover;
